/* @flow */
import * as React from 'react';
import { css, names } from 'linaria';

import { Icon, Link } from '../core';
import Colors from '../../constants/Colors';
import MediaQueries from '../../constants/MediaQueries';
import type { IconName } from '../core/Icon';

function MenuItem({ to, icon, title }: { to: string, icon: IconName, title: string }) {
  return (
    <li className={Styles.MenuItem}>
      <Link className={Styles.Link} to={to}>
        <div className={Styles.LinkIcon}>
          <Icon name={icon} />
        </div>
        {title}
      </Link>
    </li>
  );
}

function SiteServicesMenuImpl() {
  return (
    <div className={Styles.Container}>
      <div className={Styles.Arrow} />
      <nav className={Styles.MenuContainer}>
        <ul className={Styles.Menu}>
          <MenuItem to="/services/store-delivery" icon="menu-price-tag" title="Store delivery" />
          <MenuItem to="/services/small-moves" icon="menu-home" title="Small moves" />
          <MenuItem to="/services/storage-moves" icon="menu-storage-unit" title="Storage moves" />
        </ul>
        <ul className={names(Styles.Menu, Styles.LastMenu)}>
          <MenuItem
            to="/services/craigslist-delivery"
            icon="menu-handshake"
            title="Craiglist delivery"
          />
          <MenuItem to="/services/donations" icon="menu-donations" title="Donations" />
          <MenuItem to="/services/junk-removal" icon="menu-tv" title="Junk removal" />
        </ul>
      </nav>
    </div>
  );
}

export default SiteServicesMenuImpl;

const Styles = {
  Container: css`
    background-color: ${Colors.IndigoDarkest};
    box-shadow: 0 12px 40px 0 rgba(28, 31, 52, 0.15);
    position: relative;
    padding: 12px 0;
    ${MediaQueries.Medium} {
      border-radius: 10px;
      padding: 0;
    }
  `,
  Arrow: css`
    position: absolute;
    top: -6px;
    left: 50%;
    margin: 0 0 0 -6px;
    width: 12px;
    height: 12px;
    transform: rotate(45deg);
    background: ${Colors.IndigoDarkest};
    box-shadow: -3px -3px 5px rgba(82, 95, 127, 0.04);
  `,
  MenuContainer: css`
    display: flex;
    width: 100%;
    flex-direction: column;
    ${MediaQueries.Medium} {
      padding: 24px 0;
      flex-direction: row;
    }
  `,
  Menu: css`
    border-right: 1px solid ${Colors.opacity(Colors.White, 0.05)};
    ${MediaQueries.Medium} {
      width: 240px;
      padding: 0 30px;
    }
  `,
  LastMenu: css`
    border-right: none;
  `,
  MenuItem: css`
    padding: 12px 32px;
    ${MediaQueries.Medium} {
      padding: 12px 0;
    }
  `,
  Link: css`
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 16px;
    color: ${Colors.White};
    transition: opacity 200ms
    &:hover {
      opacity: 0.7;
    }
  `,
  LinkIcon: css`
    width: 36px;
    text-align: center;
    margin-right: 18px;
  `,
};



// WEBPACK FOOTER //
// ./src/ui/components/chrome/SiteServicesMenu.js